import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.flat-map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "vab-header"
};
const _hoisted_2 = {
  class: "vab-main"
};
const _hoisted_3 = {
  class: "right-panel"
};
import { useRoutesStore } from '@/store/modules/routes';
import variables from '@vab/styles/variables/variables.module.scss';

import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    layout: {
      type: String,
      default: 'horizontal'
    }
  },
  setup(__props) {
    const routesStore = useRoutesStore();
    const {
      getActiveMenu: activeMenu,
      getRoutes: routes
    } = storeToRefs(routesStore);
    return (_ctx, _cache) => {
      const _component_vab_logo = _resolveComponent("vab-logo");
      const _component_el_col = _resolveComponent("el-col");
      const _component_vab_menu = _resolveComponent("vab-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_vab_error_log = _resolveComponent("vab-error-log");
      const _component_vab_lock = _resolveComponent("vab-lock");
      const _component_vab_search = _resolveComponent("vab-search");
      const _component_vab_notice = _resolveComponent("vab-notice");
      const _component_vab_full_screen = _resolveComponent("vab-full-screen");
      const _component_vab_language = _resolveComponent("vab-language");
      const _component_vab_theme = _resolveComponent("vab-theme");
      const _component_vab_refresh = _resolveComponent("vab-refresh");
      const _component_vab_avatar = _resolveComponent("vab-avatar");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_vab_logo)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 18
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, ['horizontal' === __props.layout ? (_openBlock(), _createBlock(_component_el_menu, {
            key: 0,
            "active-text-color": _unref(variables)['menu-color-active'],
            "background-color": _unref(variables)['menu-background'],
            "default-active": _unref(activeMenu).data,
            "menu-trigger": "hover",
            mode: "horizontal",
            style: {
              "width": "100%"
            },
            "text-color": _unref(variables)['menu-color']
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes).flatMap(route => route['meta'] && route['meta']['levelHidden'] && route['children'] ? [...route['children']] : route), (item, index) => {
              return _openBlock(), _createElementBlock(_Fragment, null, [item['meta'] && !item['meta']['hidden'] ? (_openBlock(), _createBlock(_component_vab_menu, {
                key: index + item['name'],
                item: item,
                layout: __props.layout
              }, null, 8, ["item", "layout"])) : _createCommentVNode("", true)], 64);
            }), 256))]),
            _: 1
          }, 8, ["active-text-color", "background-color", "default-active", "text-color"])) : _createCommentVNode("", true), _createVNode(_component_vab_error_log), _createVNode(_component_vab_lock), _createVNode(_component_vab_search), _createVNode(_component_vab_notice), _createVNode(_component_vab_full_screen), _createVNode(_component_vab_language), _createVNode(_component_vab_theme), _createVNode(_component_vab_refresh), _createVNode(_component_vab_avatar)])]),
          _: 1
        })]),
        _: 1
      })])]);
    };
  }
});